// import axios from 'axios'
import baseURL from '../baseUrl'

// 注册
// eslint-disable-next-line camelcase
export function supplierManage(user_id, token, supplier_id) {
  var url=baseURL?'/supplierManage':'/api/supplierManage'
  return axios({
    url,
    method: 'post',
    params: {
      user_id: user_id,
      token: token,
      supplier_id: supplier_id
    }
  })
};
// 保存
// eslint-disable-next-line quotes
export function supplierSave(data, formName, method = "post") {
  var url = formName === 'add' ? (baseURL?'/supplierSave':'/api/supplierSave') : (baseURL?'/supplierEdit':'/api/supplierEdit')
  return axios({
    url: url,
    method: method,
    data: data
  })
}

// 店铺详情
export function supplierDetail(data) {
  // return axios({
  //   url: '/pc_supplierDetail',
  //   method: 'post',
  //   data: param
  // })
  var url=baseURL?'/pc_supplierDetail':'/api/pc_supplierDetail'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 店铺收藏与取消收藏
export function supplierColl(data) {
  var url=baseURL?'/pc_supplierColl':'/api/pc_supplierColl'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 发送短信验证码
export function sendCode(data) {
  var url=baseURL?'/sendCode':'/api/sendCode'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 绑定银行卡
export function bindCard(data) {
  var url=baseURL?'/bindCard':'/api/bindCard'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 解绑银行卡
export function unbindCard(data) {
  var url=baseURL?'/unbindCard':'/api/unbindCard'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// 新增-添加银行卡
export function addBankCard(data) {
  var url=baseURL?'/pc_addBankCard':'/api/pc_addBankCard'
  return axios({
    url,
    method: 'post',
    data: data
  })
}

// 新增-查询店铺银行卡
export function queryBankCard(data) {
  var url=baseURL?'/pc_queryBankCard':'/api/pc_queryBankCard'
  return axios({
    url,
    method: 'post',
    data: data
  })
}

// 新增-删除店铺银行卡
export function deleteBankCard(data) {
  var url=baseURL?'/pc_deleteBankCard':'/api/pc_deleteBankCard'
  return axios({
    url,
    method: 'post',
    data: data
  })
}

//收入明细
export function getSupplierBill(data) {
  var url=baseURL?'/pc_getSupplierBill':'/api/pc_getSupplierBill'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/supplier/supplier.js